import Checkbox from 'components/CustomCheckbox/CustomCheckbox.jsx';
import React from 'react';
import 'react-select/dist/react-select.css';

// class CheckboxWidget extends Component {
//
//   constructor(props) {
//     super(props);
//     this.state = {}
//     console.log("value", this.props);
//
//   }
//
//   onChange = () => {
//     let value = (this.props.value == 'On')? false : true;
//     console.log(value);
//     this.props.onChange(value)
//   }
//
//   render() {
//     let {checked} = this.state;
//     return (
//       <Checkbox number={this.props.id} label="First Checkbox" checked={checked} onChange={this.onChange} />
//     );
//   }
// };

const CheckboxWidget = function(props) {
    return (
        <Checkbox
            number={props.id}
            label={props.schema.title}
            value={true}
            checked={props.value}
            onChange={() => props.onChange(!props.value)}
        />
    );
};

export default CheckboxWidget;



// WEBPACK FOOTER //
// ./src/lib/widget-checkbox.js